require('jquery-mask-plugin');
require('./delivery-postal-code-input/delivery-postal-code-input.scss');
var Button = require('treeline-shared-components/button.js');
var SpinnerButton = require('treeline-shared-components/spinner-button');
var BaseViews = require('../base');

var DeliveryPostalCodeFormInput = BaseViews.LayoutView.extend({
    className: 'fmcy-delivery-postal-code-input',
    template: require('./delivery-postal-code-input/delivery-postal-code-input.html'),
    ui: {
        postalCodeInput: '#fmcy-delivery-postal-code-input-field',
        alertMessage: '.fmcy-delivery-postal-code-input-alert-message',
        alertMessageText: '.alert-danger',
        buttonVerify: '.verify-click-here'
    },
    initialize: function (options) {
        var self = this;
        self.options = _.defaults(
            options || {},
            {
                _appChannel: null,
                error: false,
                errorMessage: '',
                defaultErrorMessage: 'Please verify your postal code.'
            }
        );
    },
    regions : {
      verifyButtonRegion: '.fmcy-verify-button-region'
    },
    validateVisitedFieldsOnly: false,
    modelEvents: function () {
        var self = this;
        return _.extend(
            {},
            _.result(BaseViews.LayoutView.prototype, 'modelEvents'),
            {
                validated: self.maybeDisplayValidationAlert.bind(self)
            }
        );
    },
    validatedFields: function () {
        var validatedFields = [
          'local_delivery_postal_code'
        ];
        return validatedFields;
    },
    setAlertMessage: function(msg) {
        this.ui.alertMessageText.html(msg)
    },
    toggleValidationAlert: function (show) {
        if (show) {
            this.ui.alertMessage.removeClass('hidden');
        } else {
            this.ui.alertMessage.addClass('hidden');
        }
        this.trigger('toggle:validation:alert', show)
    },
    maybeDisplayValidationAlert: function () {
        if (this.$el.find('.has-error').length) {
            this.toggleValidationAlert(true);
        } else {
            this.toggleValidationAlert(false);
        }
    },
    onModelAttributeValid: function (attr, selector) {
        if (BaseViews.LayoutView.prototype.onModelAttributeValid.call(this, attr, selector)) {
            this.maybeDisplayValidationAlert();
        }
    },
    onModelAttributeInvalid: function (attr, error, selector, hideAlertMessage) {
        if (BaseViews.LayoutView.prototype.onModelAttributeInvalid.call(this, attr, error, selector)) {
            this.setAlertMessage(this.options.defaultErrorMessage);
            if (!hideAlertMessage) {
              this.maybeDisplayValidationAlert();
            }
        }
    },
    bindings: function () {
        var options = {
            events: ['blur'],
            setOptions: {
                validate: false
            }
        };

        var bindings = {
            '[name=local_delivery_postal_code]':
                _.extend(
                    {},
                    options,
                    { observe: 'local_delivery_postal_code' }
                )
        };

        return bindings;
    },
    events: function () {
        var self = this;

        function setVisited (ev) {
            self._setElementAsVisited($(ev.target));
        }
        return {
            'blur input': setVisited,
            'click select': setVisited,
            keydown: 'keyAction'
        };
    },
    keyAction: function(event) {
        var code = event.keyCode || event.which;

        // enter key
        if (code == 13) {
            this._onVerifyPostalCode(null);
        }
    },
    _onVerifyPostalCode: function (event) {
      var isValid = this.model.isValid(['local_delivery_postal_code']);
      if (isValid) {
        this.trigger('validate:postal:code', this.model.get('local_delivery_postal_code'));
      } else {
        this.resetVerifyButton();
      }
    },
    _renderVerifyButton: function () {
        var self = this;
        this.verifyButton = new SpinnerButton.SpinnerButton({
            label: 'VERIFY',
            multiClick: false,
            classNames: 'fmcy-verify-btn',
            theme: SpinnerButton.THEMES.PRIMARY,
            size: SpinnerButton.SIZES.LARGE,
            onClickedCallback: function () {
                self.verifyButton.toggleSpinner(true);
                self.verifyButton.toggledEnabledState(false);
                self._onVerifyPostalCode(null);
            }
        });
        this.verifyButtonRegion.show(this.verifyButton);
    },
    resetVerifyButton: function () {
        this.verifyButton.toggleSpinner(false);
        this.verifyButton.toggledEnabledState(true);
    },
    onRender: function () {
        this.ui.postalCodeInput.mask("S#S #S#");
        this._renderVerifyButton();

        if (this.options.error) {
            if (this.options.errorMessage) {
                this.setAlertMessage(this.options.errorMessage);
            } else {
                this.setAlertMessage(this.options.defaultErrorMessage);
            }
            this.toggleValidationAlert(true);
        }

        BaseViews.LayoutView.prototype.onRender.call(this);
    },
    serializeData: function () {
        return {
            defaultErrorMessage: this.options.defaultErrorMessage
        }
    },
});
module.exports = DeliveryPostalCodeFormInput;



/** WEBPACK FOOTER **
 ** ./assets/js/common/delivery-postal-code-form/delivery-postal-code-input.js
 **/